import { Button } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import { path } from "../../../utils/common/constant";

interface VisaRequestStatusTableProps {
  data: IVisaStatus[];
}

const VisaRequestStatusTable: React.FC<VisaRequestStatusTableProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: ColumnsType<IVisaStatus> = [
    {
      title: t("number_short"),
      key: "index",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Passport number",
      dataIndex: "passport_id",
      key: "passport_id",
      render: (_, record) => <p className="font-bold">{record.passport_id}</p>,
    },
    {
      title: "Full name",
      dataIndex: ["middle_and_given_name", "surname"],
      key: "full_name",
      render: (_, record) => (
        <p>
          {record.middle_and_given_name} {record.surname}
        </p>
      ),
    },
    {
      title: "Status",
      dataIndex: "request_status",
      key: "request_status",
      render: (_, record) => (
        <p className="font-bold">{record.request_status}</p>
      ),
    },
    {
      title: "Request date",
      dataIndex: "create_date",
      key: "create_date",
      render: (_, record) => (
        <p>{dayjs(record.create_date).format("DD / MM / YYYY")}</p>
      ),
    },
    {
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => handleView(record.request_id, record.request_status)}
        >
          View
        </Button>
      ),
    },
  ];

  const handleView = (request_id: number, request_status: string) => {
    if (!request_id || !request_status) return;
    navigate(path.PROFILE_RESULT, { state: { request_id, request_status } });
  };

  return (
    <Table<IVisaStatus>
      columns={columns}
      dataSource={data}
      rowKey={(record) => record.request_id}
      pagination={false}
    />
  );
};

export default VisaRequestStatusTable;
